import { useEffect, useRef } from "react";
import { formatISODate } from "../utils/dates/dateFunc";
import { useAppDispatch, useAppSelector } from "../store";
import { recheckAuthStatus } from "../store/actions/auth";
import { resetCurrentDateString } from "../store/actions/layout";

/**
 * Daily menu filters refresh.
 */
export default () => {
  const intervalRef = useRef(0);
  const lastCheckedDate = useRef(formatDate(new Date(Date.now())));
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }
    intervalRef.current = window.setInterval(() => {
      const currentDateString = formatDate(new Date(Date.now()));
      if (lastCheckedDate.current < currentDateString) {
        // Daily menu filters refresh time!
        dispatch(recheckAuthStatus());

        // Daily current date string refresh (need to update options recent week, months, quarters and etc.)
        dispatch(resetCurrentDateString());

        lastCheckedDate.current = currentDateString;
      }
    }, 5000);
    return () => {
      window.clearInterval(intervalRef.current);
    };
  }, [dispatch, isAuthenticated]);
};

function formatDate(date: Date) {
  return formatISODate(date);
}
